module.exports = __webpack_public_path__ + "img/nomad4.cb1050bd.jpg";